import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from "rxjs/operators";
//import {IQA} from '../Interfaces/iqa';
import { environment } from './../../environments/environment';
import { JsonUtilityBody } from './../Shared/json-utility-body';

@Injectable({
  providedIn: 'root'
})
export class PartyService {
  private serviceUrl: string = environment.production ? "/api" : "/api";

  constructor(private http: HttpClient) { }

  getPartySummary(id: string): Observable<any> {
    // const h = new HttpHeaders({       
    //   'Authorization': token
    // });
    // return this.http.get<any>(this.serviceUrl+"/PartySummary/"+id,{headers:h}).pipe(tap(data => JSON.stringify(data)),

    return this.http.get<any>(this.serviceUrl + "/PartySummary/" + id).pipe(tap(data => JSON.stringify(data)),
      catchError(this.handleError));
  }
  /** GET heroes from the server */
 
  getNoteTypes(path: string): Observable<any> {
    //  return this.http.post<any>(this.serviceUrl+"/queryservice/_execute",{

    // }    
    // ).pipe(tap(data => JSON.stringify(data)),
    // catchError(this.handleError));
    let url = this.serviceUrl + "/iqa?queryname=" + path ;
    //?queryname="+path+"&parameter=eq:"+id
    return this.http.get<any>(url).pipe(tap(data => data),
      catchError(this.handleError));

  }

  getIQAResult(path: string, id: string, entity?: string, excludedMeetingId?: string, pageSize? : number ,Offset ? : number): Observable<any> {
    //  return this.http.post<any>(this.serviceUrl+"/queryservice/_execute",{

    // }    
    // ).pipe(tap(data => JSON.stringify(data)),
    // catchError(this.handleError));
  
    let url =  this.serviceUrl + "/iqa?queryname=" + path + "&parameter=eq:" + id + "&parameter=eq:" + entity + "&parameter=eq:" + excludedMeetingId + (pageSize !== null?  "&Limit=" + pageSize : "") + (Offset > 0 ? "&Offset="+Offset : "");
    //?queryname="+path+"&parameter=eq:"+id
    return this.http.get<any>(url).pipe(tap(data => data),
      catchError(this.handleError));
  }

  addWorksiteRecord(meeting): Observable<any>{
    let person = {
      id : meeting.WorksiteId
    }      
    return this.addAttendanceRecord(person,meeting);
  }

  updateWorksiteRecord(meeting, meetingNote?): Observable<any>{
    // meetingNote is needed later when updating
    return this.UpdateAttendanceRecord(meeting, meetingNote);
  }

  addAttendeeRecord(meeting): Observable<any>{
    let person = {
      id : meeting.memberId
    }      
    return this.addAttendanceRecord(person,meeting);
  }

  addIntegrityCheck(person: any,meeting : any) : Observable<any>{
    if (person === null || person.id === null){
      return  of(null);
    }
    let url = this.serviceUrl + "/i4u_UT_Integrity";
    //?queryname="+path+"&parameter=eq:"+id
   let jsonBody = new JsonUtilityBody().IntegrityCheckActivityJson(person,meeting);
    return this.http.post<any>(url,jsonBody).pipe(tap(data => data),
    catchError(this.handleError));
  }

  addAttendanceRecord(worksite: any,meeting : any): Observable<any> {
   
    if (worksite === null || worksite.id === null){
      return  of(null);
    }
    let url = this.serviceUrl + "/i4u_UT_SiteVisits";
    //?queryname="+path+"&parameter=eq:"+id
    let attendanceJson = new JsonUtilityBody().AttendanceActivityJson(worksite,meeting);
    return this.http.post<any>(url,attendanceJson).pipe(tap(data => data),
      catchError(this.handleError));

  }

  addMemberAttendanceRecord(person: any,meeting : any): Observable<any> {
   
    if (person === null || person.id === null){
      return  of(null);
    }
    let url = this.serviceUrl + "/i4u_UT_SiteNotes";
    //?queryname="+path+"&parameter=eq:"+id
    let attendanceJson = new JsonUtilityBody().MemberAttendanceActivityJson(person,meeting);
    return this.http.post<any>(url,attendanceJson).pipe(tap(data => data),
      catchError(this.handleError));

  }

  AddNewNonMemberRecord(person: any,meeting : any) {
  
      let jsonBody =  new JsonUtilityBody().GetAddPartyJson(person,meeting);
      
      let url =  this.serviceUrl + "/Party";

      return this.http.post<any>(url,jsonBody).pipe(tap(data => data),
      catchError(this.handleError));
  }

  UpdateEntityOnRecord(person:any){
    let url  = this.serviceUrl+'/_i4u_UT_Contact/'+person.id;
    let jsonBody = new JsonUtilityBody().EntityContactJson(person);
    return this.http.put<any>(url,jsonBody).pipe(tap(data => data),
      catchError(this.handleError));
  }

  RetrieveAttendanceRecord(meeting:any){
    let url  = `${this.serviceUrl}/i4u_UT_SiteVisits/${meeting.MeetingId}`;
    return this.http.get<any>(url).pipe(tap(data => data),
      catchError(this.handleError));
  }

  UpdateAttendanceRecord(meeting:any, meetingNote? : any){
    let url  = `${this.serviceUrl}/i4u_UT_SiteVisits/${meeting.MeetingId}`;
    // console.log(`original payload:${JSON.stringify(originalData)}`);
    // console.log(`updated meeting:${JSON.stringify(new JsonUtilityBody().EntityMeetingJson(meeting))}`);
    let jsonBody = new JsonUtilityBody().EntityMeetingJson(meeting);
    return this.http.put<any>(url,jsonBody).pipe(tap(data => data),
      catchError(this.handleError));
  }

  getConfig() {
    // get MeetingRosterConfig IQA via DocumentVersionKey
    let url =  this.serviceUrl + "/query?QueryDocumentVersionKey=3f8123f0-716e-44e6-80be-48c104e545f2";
    //?queryname="+path+"&parameter=eq:"+id
    return this.http.get<any>(url).pipe(tap(data => data),
      catchError(this.handleError));
  }

  CheckForExistingRecords(path:string,meeting:any,person:any):Observable<any>{
    let url = this.serviceUrl + "/iqa?queryname=" + path + "&parameter=eq:" + meeting.WorksiteId  + "&parameter=eq:" + person.firstName + (person.middleName === null || person.middleName === undefined || person.middleName==="" ? "%": " " + person.middleName) + (person.lastName===""?"":" " + person.lastName);
    return this.http.get<any>(url).pipe(tap(data => data),
    catchError(this.handleError));
  }

  async CheckAlreadyRegisteredAttendees(meetingId: string): Promise<string[]> {
    try {
      const records = await this.CheckForAlreadyRegisteredRecords("$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/Meeting_Attendants_List", meetingId)
        .toPromise();
  
      // Extract the list of "Member id" values from the response
      return records.Items.$values
        .map((item: any) => {
          const memberIdProp = item.Properties.$values.find(prop => prop.Name === "Member id");
          return memberIdProp?.Value;
        })
        .filter((id: string) => id !== undefined);
    } catch (error) {
      console.error("Error fetching already registered attendees:", error);
      return [];
    }
  }

  CheckForAlreadyRegisteredRecords(path:string,meetingId:string):Observable<any>{
    let url = this.serviceUrl + "/iqa?queryname=" + path + "&parameter=eq:" + meetingId;
    return this.http.get<any>(url).pipe(tap(data => data),
    catchError(this.handleError));
  }

  private handleError(err: HttpErrorResponse) {

    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.statusText}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
